import { post } from '@common/Http';
import { CUSTOMER_VISITOR_NEW } from '@routes';
import { get as getCookie, getDecodedCookie } from './cookie';

const visitorCookieName = 'bzt';
const visitorDataCookieName = 'bzt_data';
const favoriteBrandsCountPartName = 'BC';
const customerIdPartName = 'CI';
let visitorFetchPromise = null;

/**
 * Parses data cookie into object
 * @param cookie
 * @param keyToMatch
 * @returns {{}}
 */
const parseDataCookie = (cookie, keyToMatch) => {
    const variables = decodeURIComponent(cookie).split(':');
    const parsedCookie = {};

    for (let iter = 0; iter < variables.length; iter++) {
        const [key, value] = variables[iter].split('=');

        parsedCookie[key] = value;

        if (keyToMatch && key === keyToMatch) {
            break;
        }
    }

    return parsedCookie;
};

const getDataCookie = ({ dataCookie, serverSide }) => {
    if (serverSide) {
        return dataCookie;
    }

    return getCookie(visitorDataCookieName);
};

export const getFavoriteBrandsCount = (config) => {
    const favoriteBrandsCountFromCookie = parseDataCookie(
        getDataCookie(config),
        favoriteBrandsCountPartName
    )[favoriteBrandsCountPartName];

    if (favoriteBrandsCountFromCookie) {
        return parseInt(favoriteBrandsCountFromCookie, 10);
    }

    return 0;
};

export const getVisitorId = (cookieData) => {
    const visitorIdFromCookie = getDecodedCookie(visitorCookieName, undefined, cookieData).split(':')[1];

    if (visitorIdFromCookie) {
        return parseInt(visitorIdFromCookie, 10);
    }

    return 0;
};

// eslint-disable-next-line radix
export const getFavoriteBrandsLastUpdated = cookieData => parseInt(getDecodedCookie('BLU', '0', cookieData), 0);

export const handleVisitorCookieFetch = async () => {
    const hasVisitorCookie = getCookie(visitorCookieName, null) !== null;

    if (!hasVisitorCookie) {
        if (!visitorFetchPromise) {
            try {
                visitorFetchPromise = post(CUSTOMER_VISITOR_NEW);
                await visitorFetchPromise;
            } catch (error) {} finally {
                visitorFetchPromise = null;
            }
        } else {
            await visitorFetchPromise;
        }
    }
};

/**
 * Get visitor data cookie value
 *
 * @returns object
 */
export const getVisitorDataCookieAsObject = () => {
    const cookie = getCookie(visitorDataCookieName);

    return parseDataCookie(cookie);
};

export const getCustomerDataFromCookie = (dataPartName, defaultValue) => {
    const cookie = getCookie(visitorDataCookieName);
    const valueFromCookie = parseDataCookie(cookie, dataPartName)[dataPartName];

    return valueFromCookie || defaultValue;
};

export const getCustomerId = () => getCustomerDataFromCookie(customerIdPartName, 0);
